import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class TamDashboardMapTileService {
    feedbackSubject$: Subject<any> = new Subject<any>();
}
